<template>
  <div class="question-item">
    <div class="question-item__info" @click="detailAction(0)">
      <div class="user-info">
        <img class="avatar" :src="item.avatar" alt="">
        <div class="info">
          <p class="name text-overflow">{{item.userName}}</p>
          <p class="hospital text-overflow">{{item.hospitalName}} {{item.title}}</p>
        </div>
      </div>
      <h4 class="title text-overflow">{{item.subject}}</h4>
      <div class="content">
        <p class="text">{{item.detail.description}}</p>
        <div class="imgBox">
          <img class="cover" :src="item.detail.files[0]" alt="" v-if="item.detail.files.length">
        </div>
      </div>
      <div class="btn">
        <div class="item comment">
          <i></i>
          <span>{{ item.commentCount }}</span>
        </div>
      </div>
    </div>

    <div class="question-item__reply" v-show="item.remarks.length" @click="detailAction(1)">
      <div class="reply-item" v-for="remark in item.remarks" :key="remark.remarkId">
        <div class="user">
          <img class="avatar" :src="remark.userAvatar" alt="">
          <div class="info">
            <p class="name">
              <span class="text-overflow">{{remark.userName}}</span>
              <i :class="[item.role]"></i>
            </p>
            <p class="title text-overflow">{{remark.hospitalName}} {{remark.title}}</p>
          </div>
        </div>
        <div class="content">
          {{remark.comment}}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'

const $router = useRouter()

const props = defineProps({
  item: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const detailAction = value => {
  $router.push(`/exercise/question/detail?id=${props.item.dialogId}${value ? '&type=1' : ''}`)
}

</script>
<style lang="scss" scoped>
.question-item {
  padding: 50px 32px 34px;
  background-color: #fff;
  margin-bottom: 16px;

  &__info {
    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .avatar {
        width: 68px;
        height: 68px;
        border-radius: 50%;
        margin-right: 16px;
        background-color: black;
      }
      .info {
        .name {
          color: #212224;
          font-size: 28px;
        }
        .hospital {
          color: #969799;
          font-size: 24px;
        }
      }
    }

    .title {
      color: #212224;
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 16px;
    }
    .content {
      display: flex;
      align-items: center;
      margin-bottom: 34px;
      justify-content: space-between;
      .text {
        flex: 1;
        color: #626366;
        max-height: 144px;
        line-height: 48px;
        font-size: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-right: 24px;
      }
      .imgBox {
        max-width: 180px;
        height: 136px;
        overflow: hidden;
        box-shadow: 0 0 1PX #ccc;
        border-radius: 7px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .item {
        display: flex;
        align-items: center;
        i {
          display: inline-block;
          margin-right: 8px;
          background-size: cover;
          height: 32px;
        }
        span {
          color: #969799;
          font-size: 24px
        }
      }
      .like {
        margin-right: 62px;
        i {
          width: 32px;
          background-image: url('~@/components/exercise/img/question_like_icon.png');
        }
      }
      .comment {
        i {
          width: 34px;
          background-image: url('~@/components/exercise/img/question_reply_icon.png');

        }
      }
    }
  }
  &__reply {
    border-top: 2px solid #F5F5F7;
    padding: 30px 42px 0;
    margin-top: 26px;
    .reply-item {
      .user {
        display: flex;
        margin-bottom: 16px;
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: inline-block;
          margin-right: 16px;
        }
        .info {
          .name {
            display: flex;
            align-items: center;
            span {
              display: inline-block;
              color: #212224;
              font-size: 28px;
              max-width: 200px;
              margin-right: 8px;
            }
            i {
              display: inline-block;
              width: 100px;
              height: 40px;
            }
            i {
              width: 100px;
              height: 40px;
              background-size: cover;
            }
            .ASSISTANT {
              background-image: url('~@/components/exercise/img/question_assistant_icon.png');
            }
            .LECTURER {
              background-image: url('~@/components/exercise/img/question_lector_icon.png');
            }
            .COACH {
              background-image: url('../img/question_coach_icon.png');
            }
          }
          .title {
            color: #969799;
            font-size: 24px;
          }
        }
      }
      .content {
        padding-left: 56px;
        color: #626366;
        font-size: 28px;
        line-height: 40px;
      }
    }
  }
}
</style>
